export default {
  sui: {
    loading: {
      text: 'Desperately loading'
    },
    form: {
      more: 'More',
      zhankai: 'More',
      shouqi: 'Hide',
      query: 'Query',
      reset: 'Reset',
      add: 'Add',
      update: 'Update',
      delete: 'Delete',
      required: 'is required',
      export: {
        export: 'Export',
        selectFormat: 'select format',
        selectedRow: '{key} rows selected',
        selectedTotal: '{key} lines in total,export',
        line: 'line'
      },
      please: {
        input: 'input ',
        select: 'select '
      },
      time: {
        start: 'start time',
        end: 'end time',
        to: 'To'
      },
      date: {
        start: 'start date',
        end: 'end date'
      },
      upload: {
        triggerText: 'upload'
      },
      expand: 'Expand',
      multiple: 'Multiple',
      cols_hide: 'Header setting'
    },
    table: {
      handle: 'Handle',
      sum: 'Sum',
      index: 'Index',
      zanwushuju: 'no data',
      queding: 'Ok',
      quxiao: 'Cancel',
      lie: 'Column',
      yiyincang: 'Hidden',
      gong: 'Total'
    },
    tableEdit: {
      tip1: 'The data is still in editing state and cannot be saved!',
      tip2: 'Are you sure to delete the data?',
      baocun: 'Save',
      chongzhi: 'Reset',
      xinzeng: 'add',
      guanbituozhuai: 'close draggable',
      kaiqituozhuai: 'open draggable',
      caozuo: 'Handle',
      queren: 'Ok',
      bianji: 'Edit',
      shanchu: 'Delete',
      tishi: 'tips'
    },
    list: {
      yi_xuan_ze: 'selected',
      tiao: 'items',
      gong: 'total',
      mei_you_geng_duo: 'no more',
      zan_wu_shu_ju: 'No data is selected yet'
    },
    bond: {
      zheng_quan_dai_ma: 'bond code',
      zheng_quan_ming_cheng: 'bond name',
      zan_wu_shu_ju: 'no data',
      qu_xiao_qing_qiu: 'request has been canceled'
    },
    dialog: {
      ok: 'Ok',
      cancel: 'Cancel'
    },
    page: {
      add: {
        success: 'add [{key}] success'
      },
      delete: {
        title: '{key}-delete',
        confirm: 'confirm delete [{key}] ?',
        success: 'delete [{key}] success'
      },
      update: {
        success: 'update [{key}] success',
        noChange: 'data not change, not save'
      }
    },
    tablePage: {
      export: {
        tip1: 'please enter the correct line number',
        tip2: 'export type',
        tip3: 'select',
        tip4: ' export as',
        tip5: 'please select export file type',
        lie: 'column',
        hang: 'line',
        shi: 'yes',
        fou: 'no',
        daochu: 'Export',
        wancheng: 'Confirm',
        quxiao: 'Cancel',
        gong: 'Total',
        type1: 'sequential export',
        type2: 'manual tick export',
        daochu_geshi: 'export file type'
      }
    },
    editlist: {
      caozuo: 'Handle',
      shanchu: 'Delete',
      xinzeng: 'Add'
    },
    upload: {
      tip1: 'press the delete key to delete'
    },
    uploadPro: {
      tip1: 'Websocket connection lost, trying to connect again',
      tip2: 'connection dropped'
    },
    select: {
      jiazaizhong: 'loading',
      wupipeishuju: 'no matching data',
      wushuju: 'no data',
      quanxuan: 'select all',
      fanxuan: 'inverse'
    },
    transfer: {
      tip1: 'search',
      liebiao1: 'List 1',
      liebiao2: 'List 2'
    },
    treeGrid: {
      caozuolan: 'Handle'
    },
    empty: {
      zanwuneirong: 'no data'
    },
    valid: {
      char: 'char',
      len1: 'please enter {p1} ',
      len2: 'please enter {p1} to {p2} ',
      num: 'number char',
      pInt: 'positive integer',
      npInt: 'non-positive integer',
      nInt: 'negtive integer',
      nNInt: 'non-negtive integer',
      int: 'integer',
      pFNum: 'positive floating number',
      nFNum: 'negtive floating number',
      num_: 'number(-,_) char',
      en: 'english char',
      en_: 'english(-,_) char',
      ch: 'chinese char',
      ch_: 'chinese(-,_) char',
      nch: 'un-chinese char',
      numEn: 'number or english char',
      numEn_: 'number or english(-,_) char',
      chEnNum: 'number or english or chinese char',
      chEnNum_: 'number or english or chinese(-,_) char',
      phone: 'phone char',
      email: 'email char',
      idcard: 'idcard char',
      url: 'url char',
      reg: 'please enter right ',
      version: 'version tag',
      uri: 'uri',
      datasource: 'data source',
      intRegion: 'integer enter {p1} to {p2}',
      floatRegion: 'float enter {p1} to {p2}'
    },
    timerange: {
      jue_dui_shi_jian_fan_wei: 'Absolute time range',
      xiang_dui_shi_jian_fan_wei: 'Relative time range',
      kai_shi_shi_jian: 'Starting time',
      jie_su_shi_jian: 'End Time',
      zui_jin_wu_fen_zhong: 'Last 5 minutes',
      zui_jin_shi_wu_fen_zhong: 'Last 15 minutes',
      zui_jin_san_shi_fen_zhong: 'Last 30 minutes',
      zui_jin_yi_xiao_shi: 'Last 1 hour',
      zui_jin_san_xiao_shi: 'Last 3 hours',
      zui_jin_liu_xiao_shi: 'Last 6 hours',
      zui_jin_shi_er_xiao_shi: 'Last 12 hours',
      zui_jin_er_shi_si_xiao_shi: 'Last 24 hours',
      zui_jin_liang_tian: 'Last 2 days',
      zui_jin_qi_tian: 'Last 7 days',
      zui_jin_san_shi_tian: 'Last 30 days'
    },
    bookmark: {
      biao_ti: 'bookmark',
      xin_zeng_shu_qian: 'add bookmark',
      ming_cheng: 'name',
      fu_gai: 'covered',
      chong_ming_ming: 'rename',
      shan_chu: 'delete',
      ming_cheng_xiu_gai_cheng_gong: 'Name modified successfully',
      xin_zeng: 'add',
      shan_chu_ti_shi: 'confirm delete [{name}] ?',
      shan_chu_cheng_gong: 'successfully deleted',
      xin_zeng_cheng_gong: 'Add bookmark successfully!',
      tian_jia_ji_lu: 'add to history',
      gong: 'total',
      tiao: 'items',
      bao_cun: 'save',
      qing_wan_cheng_zheng_zai_tian_jia_xiang: 'Please confirm that the record is being added'
    },
    messageBox: {
      qing_shuru_yanzhengma: 'Please enter verification code',
      yanzhengma_bu_zhengque: 'Incorrect verification code'
    },
    jsonEditor: {
      fuzhi: 'copy'
    },
    cron: {
      second: 'second',
      minute: 'minute',
      hour: 'hour',
      day: 'day',
      month: 'month',
      week: 'week',
      year: 'year',
      cron_biaodashi_ziduan: 'Cron expression field',
      hanhua_fanyi: 'Chinese translation',
      chongzhi: 'Reset',
      single: 'per ',
      mei_nian: 'per year',
      mei_yue: 'per month',
      mei_ri: 'per day',
      mei_tian: 'per day',
      mei_shi: 'per hour',
      xiaoshi: 'hour',
      mei_fenzhong: 'per minute',
      mei_miao: 'per second',
      mei_zhou: 'per week',
      cong: 'from',
      yue_qi_mei_ge: 'every month',
      ri_qi_mei_ge: 'every day',
      shi_qi_mei_ge: 'every hour',
      fenzhong_qi_mei_ge: 'evert minute',
      miao_qi_mei_ge: 'every second',
      zuihou_yitian: 'last day',
      zhi: 'to',
      cong_zhou: 'from week',
      zhi_zhou: 'to week',
      qi_meige: 'every',
      tian_zhixingyici: ' once a day',
      xiaoshi_zhixingyici: ' once an hour',
      yue_zhixingyici: ' once a month',
      zhixingyici: ' execute once',
      ben_yue_di: 'this month',
      ben_yue: 'this month',
      xinqi: 'week',
      benyue_zuihou_yige_xingqi: 'Last week of the month',
      buzhiding: 'Not specify',
      zhouqi_cong: 'Cycle from',
      xunhuan_cong: 'Loop from',
      tip1: 'every day',
      tip2: 'the nearest working day',
      tip3: 'begin, every hour ',
      tip4: 'begin, every month',
      tip5: "week's day",
      benyue_zuihou_yitian: 'Last day of the month',
      zhiding: 'Specify',
      kaishi: 'begin',
      kaishi_mei: 'begin every',
      benyue: 'this month',
      mei: 'every ',
      zhixing: 'execute',
      zhouqi: 'Cycle',
      di: 'No',
      mess1: "Date and week cannot be 'not specified' at the same time",
      mess2: "One of the days and weeks must be 'not specified'",
      zhouri: 'Sunday',
      zhouyi: 'Monday',
      zhouer: 'Tuesday',
      zhousan: 'Wednesday',
      zhousi: 'Thursday',
      zhouwu: 'Friday',
      zhouliu: 'Saturday'
    },
    treeGraph: {
      fangda: '放大',
      suoxiao: '缩小',
      shuaxin: '刷新'
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/SimbartUI/lang/en-US.js